import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { 
  Paper, 
  Typography, 
  Grid, 
  Card, 
  CardContent,
  CardActionArea,
  Box 
} from '@material-ui/core';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SettingsIcon from '@material-ui/icons/Settings';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  welcomeCard: {
    backgroundColor: theme.palette.primary.main,
    color: 'white',
    marginBottom: theme.spacing(4),
  },
  welcomeContent: {
    padding: theme.spacing(3),
  },
  card: {
    height: '100%',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'translateY(-4px)',
    },
  },
  cardContent: {
    textAlign: 'center',
    padding: theme.spacing(3),
  },
  icon: {
    fontSize: 48,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
  cardTitle: {
    marginBottom: theme.spacing(1),
  },
  cardDescription: {
    color: theme.palette.text.secondary,
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  const cards = [
    {
      title: 'Locations',
      description: 'Manage seller and fulfillment locations',
      icon: <LocationOnIcon className={classes.icon} />,
      route: '/location/sellerLocation'
    },
    {
      title: 'Settings',
      description: 'Configure system settings and preferences',
      icon: <SettingsIcon className={classes.icon} />,
      route: '/publish/activity'
    },
  ];

  return (
    <div className={classes.root}>
      <Paper className={classes.welcomeCard} elevation={0}>
        <Box className={classes.welcomeContent}>
          <Typography variant="h4" gutterBottom>
            Welcome{user.name ? `, ${user.name}` : ''}
          </Typography>
          <Typography variant="subtitle1">
            Manage your address mapping and configurations from this dashboard
          </Typography>
        </Box>
      </Paper>

      <Grid container spacing={4}>
        {cards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card className={classes.card}>
              <CardActionArea onClick={() => history.push(card.route)}>
                <CardContent className={classes.cardContent}>
                  {card.icon}
                  <Typography variant="h6" className={classes.cardTitle}>
                    {card.title}
                  </Typography>
                  <Typography variant="body2" className={classes.cardDescription}>
                    {card.description}
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Dashboard; 